import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=2d26badb&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d26badb')) {
      api.createRecord('2d26badb', component.options)
    } else {
      api.reload('2d26badb', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=2d26badb&", function () {
      api.rerender('2d26badb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/Detail.vue"
export default component.exports